import { FollowWithUser } from '../models';
import { FollowRepository } from '../repositories';
import { logger } from '@/src/core/utils';

export class GetFollowersUseCase {
  constructor(private followRepository: FollowRepository) {}

  async execute(userId: string, limit?: number, offset?: number): Promise<FollowWithUser[]> {
    logger.debug('GetFollowers', 'Fetching followers', { userId });

    const followers = await this.followRepository.getFollowers(userId, limit, offset);

    logger.debug('GetFollowers', 'Found followers', { count: followers.length });

    return followers;
  }
}
